import { render } from "./RenderingRandselName.vue?vue&type=template&id=27d1dae1&scoped=true&ts=true"
import script from "./RenderingRandselName.vue?vue&type=script&lang=ts"
export * from "./RenderingRandselName.vue?vue&type=script&lang=ts"

import "./RenderingRandselName.vue?vue&type=style&index=0&id=27d1dae1&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d1dae1"]])

export default __exports__